import React from 'react';

interface SpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?: 'dark' | 'white' | 'yellow' | 'mid';
}

const sizeMap = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-10 w-10',
};

const colorMap = {
  dark:   'border-brand-dark border-t-transparent',
  white:  'border-white border-t-transparent',
  yellow: 'border-brand-yellow border-t-transparent',
  mid:    'border-brand-mid border-t-transparent',
};

const Spinner: React.FC<SpinnerProps> = ({ size = 'sm', color = 'dark' }) => (
  <div
    className={`inline-block animate-spin rounded-full border-2 ${sizeMap[size]} ${colorMap[color]}`}
    role="status"
    aria-label="Cargando"
  />
);

export default Spinner;
